<template>
    <div class="sign-up">
        <div class="container">
            <div v-if="!isSimple" class="sign-up__header">
                <sign-up-header class="sign-up__header-header"></sign-up-header>
            </div>
            <div class="sign-up__content">
                <h1 v-if="!isSimple" class="sign-up__content-title">Preencha o formulário abaixo</h1>

                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="8">
                        <template v-if="plan">
                            <vs-select v-if="computedPlans" v-model="planChoosed" label="Escolha seu plano"
                                       class="sign-up__content-planlist required-field">
                                <vs-select-item v-for="option in computedPlans" :key="option.id" :value="option.code"
                                                :text="option.name"/>
                            </vs-select>

                            <sign-up-register class="sign-up__content-user" ref="user" :simple="isSimple"
                                              :values="userForm" :plan="plan"
                                              @set:user="(data) => updateFormData(data, 'userForm')"/>

                            <sign-up-payment v-if="!plan.isFreemium" class="sign-up__content-payment" :plan="plan"
                                             :payment="paymentChoosed" :is-payment-running="isPaymentRunning"
                                             @setPaymentMethod="setPaymentMethod">
                                <AppPaymentCard v-if="isPaymentWithCard" ref="card" :value="plan.planValue"
                                                :installments="plan.numberInstallments"
                                                @set:card="(data) => updateFormData(data, 'cardForm')"/>

                                <AppPaymentPix v-if="isPaymentWithPix" :qr-code-text="paymentQrCode"
                                               @setPayment="setPayment"/>
                            </sign-up-payment>

                            <sign-up-user-term class="sign-up__content-term" :checked="userTerm"
                                               :error="isUserTermInvalid"
                                               :isNew="true" ref="term" @set:userTerm="(data) => userTerm = data"/>
                        </template>
                    </vs-col>

                    <vs-col vs-xs="12" vs-sm="12" vs-lg="4">
                        <sign-up-resume v-if="plan && planCode" class="sign-up__content-resume" :plan="plan"
                                        :payment="paymentChoosed" :simple="isSimple"/>

                        <vs-button class="sign-up__content-button-confirm" @click="handleClickConfirm">
                            confirmar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </div>

        <b-modal id="modal-payment-error" hide-footer centered header-border-variant="white" size="lg">
            <div class="sign-up__content-modal">
                <template v-if="isPaymentWithCard">
                    <h2 class="sign-up__content-modal-title">Transação não autorizada.</h2>
                    <p class="sign-up__content-modal-description">{{ modalMessage }}</p>

                    <vs-button class="sign-up__content-modal-button" @click="handleClickTryPayAgain">
                        Realizar nova tentativa
                    </vs-button>
                </template>
            </div>
        </b-modal>
    </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"/><script>
import {defineComponent, computed} from 'vue';
import {useStore} from "@/store/store.js";
import {plansHelper} from '@/helpers/plans';
import paymentsList from '@/constants/payments';
import mixins from "@/mixins/mixins.js";
import {trackViewItem, trackAddToCart, trackRemoveFromCart, trackPurchase, trackBeginCheckout} from "@/helpers/gtmEvents";

import AppPaymentCard from '@/components/AppPayment/AppPaymentCard.vue';
import AppPaymentPix from '@/components/AppPayment/AppPaymentPix.vue';
import SignUpHeader from './components/SignUpHeader.vue';
import SignUpRegister from "./components/SignUpRegister";
import SignUpPayment from './components/SignUpPayment.vue';
import SignUpResume from './components/SignUpResume.vue';
import SignUpUserTerm from "./components/SignUpUserTerm";

export default defineComponent({
    name: 'SignUpSimple',

    components: {
        AppPaymentCard,
        AppPaymentPix,
        SignUpHeader,
        SignUpPayment,
        SignUpRegister,
        SignUpResume,
        SignUpUserTerm
    },

    mixins: [mixins],

    setup() {
        const store = useStore();

        return {
            isMobile: computed(() => store.state.isMobile),
            getPlanByCode: (code) => store.dispatch('getPlanByCode', code),
            getPlansByMultPlanCode: (multPlanCode) => store.dispatch('getPlans', multPlanCode),
            sendRdStation: (data) => store.dispatch('sendRdStation', data),
            setNewRegister: (data) => store.dispatch('setNewRegister', data),
            validatePaymentPix: (code) => store.dispatch('validatePaymentPix', code),
            getSalesCode: (salesCode) => store.dispatch('getSalesCode', salesCode)
        };
    },

    data() {
        return {
            plan: null,
            planCode: null,
            multPlanCode: null,
            plans: null,
            planChoosed: null,
            userForm: {
                cpf: '',
                email: '',
                name: '',
                phone: ''
            },
            userTerm: false,
            cardForm: {
                name: '',
                card: '',
                expiration: '',
                cvv: '',
                cpf: ''
            },
            payments: [],
            paymentChoosed: 'cartao',
            paymentQrCode: null,
            partnerLogo: null,
            salesCode: null,
            paymentInvoice: null,
            isUserFormInvalid: false,
            isCardFormInvalid: false,
            isUserTermInvalid: false,
            isPaymentRunning: false,
            modalMessage: '',
            isGtmTracked: false
        };
    },

    computed: {
        isSimple() {
            return this.$route.meta.simple;
        },
        isPaymentWithCard() {
            return this.paymentChoosed === 'cartao';
        },
        isPaymentWithPix() {
            return this.paymentChoosed === 'pix';
        },
        isFreemium() {
            return !!this.plan.isFreemium;
        },
        computedLinkFinalization() {
            return this.isSimple ? 'SignUpSimpleFinalization' : 'PaymentConfirmation';
        },
        computedPlans() {
            if (this.plans && this.plans.packs) {
                const {freemium, single, family} = this.plans.packs;
                return [...freemium, ...single, ...family];
            }
            return null;
        },
        computedInstallments() {
            return this.plan.numberInstallments || 1;
        },
        computedCustomerData() {
            const payment = paymentsList.find(payment => payment.slug === this.paymentChoosed);
            return {
                name: this.userForm?.name,
                email: this.userForm?.email,
                cpf: this.userForm?.cpf?.replace(/\D+/g, "") || '',
                token: null,
                phone: this.userForm?.phone.replace(/\D+/g, ""),
                plan: this.plan?.code || null,
                discounts: null,
                b2b: false,
                method: this.isFreemium ? null : payment.method,
                additionalLife: 0,
                acceptanceLocation: "simple-signup",
                termsAccepted: this.userTerm,
                salesCode: this.salesCode?.salesCode || null,
                isNewCheckout: this.isFreemium
            };
        },
        computedGtmData() {
            return {
                ecommerce: {
                    currency: "BRL",
                    value: this.plan.planValue,
                    items: [{
                        item_id: this.plan.id,
                        item_name: this.plan.name,
                        discount: this.plan.discount,
                        item_brand: "Cartão Dasa",
                        price: this.plan.planValue,
                        quantity: 1
                    }]
                }
            };
        }
    },

    watch: {
        async planChoosed(val) {
            if (val !== this.plan.code) {
                trackRemoveFromCart(this.computedGtmData);
                await this.findPlanByCode(val);
                trackAddToCart(this.computedGtmData);
            }
        }
    },

    async created() {
        this.$vs.loading();

        const parameters = this.$route.query;
        const planCode = await (parameters['plan_code'] || localStorage.getItem('planCode'));
        const salesCode = await parameters['sales_code'];

        if (salesCode) {
            this.salesCode = await this.getSalesCode(salesCode);
            let date = new Date();
            date.setDate(date.getDate() + 7);

            document.cookie = `sales_code=${salesCode}; expires=${date.toUTCString()}`;
        } else {
            const cookie = document.cookie.split(';').find((code) => code.trim().split('=')[0] === 'sales_code');
            if (cookie) {
                this.salesCode = cookie.trim().split('=')[1];
            }
        }

        if (planCode) {
            await this.findPlanByCode(planCode);
            await this.initIUGU();
        } else {
            this.$router.push({name: "error404"});
        }
    },

    destroyed() {
        this.initIUGU();
        localStorage.clear();
    },

    methods: {
        initIUGU() {
            Iugu.setAccountID(this.$store.state.iuguNotifyAccountId);
            Iugu.setup();
            Iugu.setTestMode(this.$store.state.iuguTestMode);
        },

        setPaymentMethod(payment) {
            this.paymentChoosed = payment;
        },

        updateFormData(data, form) {
            Object.keys(this[form]).forEach((key) => {
                this[form][key] = typeof data[key] === 'string' ? data[key]?.trim() : data[key];
            });
        },

        async findPlanByCode(planCode) {
            const plan = await this.getPlanByCode(planCode) || null;
            if (plan) {
                this.plan = plan;
                this.planChoosed = plan.code;
                this.planCode = planCode;
                this.payments = plan.method.split(',');
                this.paymentChoosed = this.payments[0];

                this.multPlanCode = plan?.multPlanCode?.trim() || null;
                if (this.multPlanCode) {
                    const plans = await this.getPlansByMultPlanCode(this.multPlanCode);
                    this.plans = await plansHelper.compile(plans, plan);
                }

                if (plan.partnerLogo) {
                    const {fileBytes, contentType} = plan.partnerLogo;
                    this.partnerLogo = `data:${contentType};base64, ${fileBytes}`;
                }

                if (!this.isGtmTracked) {
                    trackViewItem(this.computedGtmData);
                    this.isGtmTracked = true;
                }
            } else {
                this.$router.push({name: 'error404'});
            }

            setTimeout(() => {
                this.$vs.loading.close();
            }, 250);
        },

        async handleClickTryPayAgain() {
            this.$bvModal.hide('modal-payment-error');
        },

        async handleClickConfirm() {
            await this.$vs.loading();
            await this.$refs.term.checkTermChecked();

            const chkUser = this.isFreemium || this.isPaymentWithCard || !this.paymentQrCode
                ? await this.$refs.user.checkValidFields()
                : !!this.paymentQrCode;
            const chkCard = !this.isFreemium && this.isPaymentWithCard
                ? await this.$refs.card.checkPaymentCardFields()
                : true;

            if (this.userTerm && chkUser) {
                if (this.isFreemium) {
                    await this.sendRdStation(this.computedCustomerData);
                    await this.$recaptchaLoaded();
                    this.computedCustomerData.recaptchaToken = await this.$recaptcha('purchase')
                    const response = await this.setNewRegister(this.computedCustomerData);
                    if (response && response.status === 200) {
                        localStorage.setItem('paymentMethod', 'cartao');
                        localStorage.setItem('vue-session-key', JSON.stringify(response.headers.authorization));
                        this.$router.push({name: this.computedLinkFinalization});
                        this.$vs.loading.close();
                    }
                } else if (chkCard && this.isPaymentWithCard) {
                    this.setCreditCardPayment();
                } else if (this.isPaymentWithPix) {
                    if (!this.paymentQrCode) {
                        this.$vs.loading.close();
                        this.showNotifyWarning(
                            'Para confirmar seu pedido, necessário gerar o QR Code e o código pix para pagamento clicando em “Gerar agora”.',
                            5000
                        );
                    } else {
                        await localStorage.setItem('paymentDone', await this.validatePaymentPix(this.paymentInvoice));
                        this.$vs.loading.close();
                        this.$router.push({name: this.computedLinkFinalization});
                    }
                }
            } else {
                this.$vs.loading.close();
            }
        },

        async setCreditCardPayment() {
            await this.initIUGU()

            const iuguCreditCard = await Iugu.CreditCard(
                this.cardForm.card,
                this.cardForm.expiration.split('/')[0],
                this.cardForm.expiration.split('/')[1],
                this.cardForm.name.split(' ')[0],
                this.cardForm.name.split(' ').slice(1).join(' '),
                this.cardForm.cvv
            )

            if (iuguCreditCard.valid()) {
                Iugu.createPaymentToken(iuguCreditCard.toData(), (response) => {
                    if (response?.id) {
                        this.setPayment(response.id)
                    } else {
                        this.$vs.loading.close()

                        this.showNotifyError(
                            'Erro ao validar cartão, não foi possível criar o token na Iugu',
                            6000
                        )
                    }
                })
            } else {
                this.modalMessage = 'Por favor, entre em contato com o seu banco'

                this.$vs.loading.close()
                this.$bvModal.show('modal-payment-error')
            }
        },

        async setPayment(token) {
            if (!token) {
                await this.$vs.loading();
            }

            const chkUser = await this.$refs.user.checkValidFields();
            const chkTerm = await this.$refs.term.checkTermChecked();

            if (chkUser && chkTerm) {
                await this.sendRdStation(this.computedCustomerData);
                const customerData = this.isPaymentWithCard
                    ? {...this.computedCustomerData, months: this.cardForm.installment, token}
                    : this.computedCustomerData;

                await this.$recaptchaLoaded()
                customerData.recaptchaToken = await this.$recaptcha('purchase')
                const response = await this.setNewRegister(customerData);
                const status = response.status || response.statusCode;

                localStorage.setItem('paymentStatus', status);
                localStorage.setItem('paid', response.data.paymentStatus);
                localStorage.setItem('paymentMethod', this.paymentChoosed);

                if (status === 200 && ((this.paymentChoosed === 'cartao' && response.data.paymentStatus !== 'pending') || this.paymentChoosed === 'pix')) {
                    localStorage.setItem('paymentMethod', this.paymentChoosed);
                    localStorage.setItem('paymentStatus', response.data.paymentStatus);
                    localStorage.setItem('vue-session-key', JSON.stringify(response.headers.authorization));
                    document.cookie = 'sales_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC';

                    if (this.isPaymentWithCard) {
                        localStorage.setItem('purchased', true);
                        trackPurchase(this.computedGtmData);
                        this.$router.push({name: this.computedLinkFinalization});
                    }

                    if (this.isPaymentWithPix) {
                        this.isPaymentRunning = true;
                        this.paymentInvoice = response.data.recent_invoices[0]?.id;
                        this.paymentQrCode = response.data.pix.qrcode_text;
                        trackBeginCheckout(this.computedGtmData);
                    }
                } else if (status === 412 || (response.data.paymentStatus === 'pending' && this.paymentChoosed === 'cartao')) {
                    this.$router.push({name: this.computedLinkFinalization});
                } else {
                    this.modalMessage = response.message || 'Por favor, entre em contato com o seu banco';
                    this.isPaymentWithCard ? this.$bvModal.show('modal-payment-error') : this.$vs.loading.close();
                }
            }

            this.$vs.loading.close();
        }
    }
});
</script>

<style lang="scss" scoped>
.sign-up {
    background-color: #F0F1F2;
    min-height: 99.99vh;
    padding: 1rem 0;
    position: relative;

    @media #{$md-and-up} {
        padding: 2rem 0;
    }

    @media #{$lg-and-up} {
        padding: 3rem 0;
    }

    &__content {
        &-input {
            text-transform: none;
        }

        &-title {
            font-size: 1.25rem;
            font-weight: 42px;
            margin: 2rem 0 1.5rem;
            color: #000D40;

            @media #{$lg-and-up} {
                font-size: 2rem;
                margin: 3rem 0 1rem;
            }
        }

        &-planlist {
            margin-bottom: 1rem;
            width: 100%;
            color: #282828;
            font-weight: 500;

            &:not(:first-child) {
                margin-top: 1rem;
            }

            &::v-deep {
                .vs-select--input {
                    height: 3rem;
                }
            }
        }

        &-payment {
            margin-top: 1.5rem;

            @media #{$lg-and-up} {
                margin-top: 2rem;
            }
        }

        &-term {
            margin-top: 1.5rem;

            @media #{$lg-and-up} {
                margin-top: 2rem;
            }
        }

        &-resume {
            margin-top: 2rem;

            @media #{$lg-and-up} {
                margin-top: 0;
            }
        }

        &-button {
            &-confirm {
                border-radius: 100rem;
                color: #A6E1FF;
                margin-top: 2rem;
                width: 100%;

                &::v-deep {
                    .vs-button--text {
                        text-transform: uppercase;
                    }
                }
            }
        }

        &-modal {
            padding: 0rem 0rem 3rem;
            text-align: center;
            text-transform: uppercase !important;

            &::v-deep {
                .vs-button--text {
                    text-transform: uppercase;
                }
            }

            @media #{$lg-and-up} {
                padding: 1rem 0 4rem;
            }

            &-title {
                font-size: 2rem;
                color: #000000;

                @media #{$lg-and-up} {
                    font-size: 2.5rem;
                }
            }

            &-description {
                font-size: 1.25rem;
                margin-top: .5rem;
                color: #000000;
            }

            &-button {
                border-radius: 100rem;
                color: #0137FD;
                font-size: 1rem;
                margin: 1rem auto 0;

                @media #{$lg-and-up} {
                    font-size: 1.25rem;
                    margin: 1.5rem auto 0;
                }

                &::v-deep {
                    .vs-button-text {
                        text-transform: none;
                        color: #A6E1FF;
                    }
                }
            }
        }
    }

    &--background {
        bottom: 0;
        max-width: 50%;
        opacity: .5;
        position: fixed;
        right: 0;
    }
}
</style>
